export const quizData = [
    {
        question: "QUAL È L'UNITÀ DI MISURA DELL’IRRADIANZA SOLARE?",
        options: ["a. Ampere (A)", "b. Kilowatt (kW)", "c. Watt/metro quadro (W/m2)", "d. Volt/metro (V/m)", "e. Joule (J)"],
        correct: 2,
        explanation:
            <>
                Lo sai che il valore di energia solare che colpisce la superficie del suolo italiano è pari a circa
                440.000 TWh/anno, equivalente a oltre 1.000 volte il fabbisogno energetico annuale nazionale? <br/>
                Altenia ha oltre 20 anni di esperienza nel settore fotovoltaico e può offrire servizi di EPC,
                Revamping e Repowering ed O&M su tutto il territorio nazionale. Siamo il partner ideale per il tuo
                impianto fotovoltaico.
            </>,
        index: "01"
    },
    {
        question: "QUAL È LA POTENZA COMPLESSIVA DI FOTOVOLTAICO INSTALLATA IN ITALIA A FINE 2024?",
        options: ["a. circa 18 GWp", "b. circa 25 GWp", "c. circa 37 GWp", "d. circa 65 GWp", "e. circa 88 GWp"],
        correct: 2,
        explanation: <>
            Lo sai che, nel 2024, la produzione di energia elettrica da fotovoltaico in Italia è stata di 36.000
            GWh, coprendo circa il 14% della produzione totale nazionale? <br/>
            Altenia ha complessivamente realizzato/revampato oltre 500 MWp e ha in corso d’opera altri 260
            MWp, contribuendo in modo significativo al processo di transizione energetica.
        </>,
        index: "02"
    },
    {
        question: "QUAL È IL RUOLO DI UN DIODO DI BYPASS IN UN MODULO FOTOVOLTAICO?",
        options: [
            "a. Ridurre le perdite di energia in caso di ombreggiamento parziale e rotture delle celle",
            "b. Proteggere il modulo da sovratensioni",
            "c. Regolare la tensione di uscita del modulo",
            "d. Prevenire l’inversione di corrente nei pannelli",
            "e. Aumentare l’efficienza del modulo fotovoltaico"
        ],
        correct: 0,
        explanation: <>
            Lo sai che un impianto fotovoltaico da 1 MWp può avere oltre 1.500 moduli fotovoltaici? <br/>
            Altenia ha installato oltre 2.000.000 di moduli fotovoltaici e ha esperienza e consolidati rapporti con
            i principali fornitori a livello internazionale.
        </>,
        index: "03"
    },
    {
        question: "CHE COSA È UN INVERTER FOTOVOLTAICO?",
        options: [
            "a. Un dispositivo che aumenta l'efficienza del pannello fotovoltaico",
            "b. Un dispositivo che converte l'energia termica in energia elettrica",
            "c. Un dispositivo che converte l'energia alternata (AC) in energia continua (DC)",
            "d. Un dispositivo che converte l'energia continua (DC) in energia alternata (AC)",
            "e. Un dispositivo che consente di accumulare energia"
        ],
        correct: 3,
        explanation:<>
            Lo sai che la durata di un inverter fotovoltaico è generalmente superiore a 10 anni, ma alcuni dei
            suoi componenti necessitano di sostituzione per garantire tale ciclo di vita? <br/>
            Half Bridge Automation, parte di Altenia, può riparare e rigenerare tutte le tipologie di inverter dei
            marchi più diffusi sul mercato, anche quelli fuori produzione.
        </>,
        index: "04"
    },
    {
        question: "QUALE DI QUESTI COMPONENTI NON FA PARTE DI UN INVERTER FOTOVOLTAICO?",
        options: [
            "a. Condensatore",
            "b. Isolatore elettrico",
            "c. IGBT",
            "d. Contattore",
            "e. Ventola"
        ],
        correct: 1,
        explanation: <>
            Lo sai che le cause più frequenti di rottura degli inverter sono riconducibili ai condensatori, spesso
            per mancata manutenzione predittiva. <br/>
            Half Bridge Automation, parte di Altenia, ha riparato e rigenerato oltre 40 MW di inverter fotovoltaici
            nel 2024.
        </>,
        index: "05"
    },
    {
        question: "LA MANUTENZIONE ORDINARIA DI UN TRASFORMATORE BT/MT IN OLIO NON PREVEDE:",
        options: [
            "a. Controlli fuori tensione e sotto tensione",
            "b. Controllo rigidità dielettrica dell’olio",
            "c. Pulizia degli isolatori e controllo dello stato di conservazione",
            "d. Verifica intervento relè buchholz e termometro",
            "e. Controllo ventilatori tangenziali"
        ],
        correct: 4,
        explanation: <>
            Lo sai che un impianto fotovoltaico non manutenuto può perdere tra il 15% e il 35% della sua
            capacità di produrre energia a causa di vari fattori, come per esempio lo sporco accumulato sui
            pannelli e problemi elettrici non rilevati? <br/>
            Altenia ha in gestione oltre 1 GWp di impianti e può offrire un servizio manutentivo a 360°
            comprensivo di lavaggio moduli, sfalcio erba, termografie, analisi specialistiche, monitoraggio e
            reporting.
        </>,
        index: "06"
    },
    {
        question: "QUALE PARAMETRO VIENE MONITORATO PER INDIVIDUARE EVENTUALI MALFUNZIONAMENTI NEI PANNELLI FOTOVOLTAICI?",
        options: [
            "a. La tensione e la corrente prodotta",
            "b. Il colore delle celle fotovoltaiche",
            "c. La quantità di pioggia caduta",
            "d. La temperatura del suolo sotto i pannelli",
            "e. Il numero di ore di sole giornaliere"
        ],
        correct: 0,
        explanation: <>
            Lo sai che un sistema SCADA può monitorare decine di parametri di un impianto fotovoltaico, tra
            cui irraggiamento, produzione, temperatura del modulo, tensioni in ingresso e in uscita su vari
            componenti? <br/>
            Altenia ha 3 control room, oltre 70 tecnici specializzati sparsi sul territorio nazionale e 17 magazzini
            con inverter e spare parts proprietarie e dei clienti.
        </>,
        index: "07"
    },
    {
        question: "COME SI CALCOLA IL PR (PERFORMANCE RATIO) DI UN IMPIANTO FOTOVOLTAICO?",
        options: [
            "a. Energia prodotta / Irraggiamento totale",
            "b. Energia prodotta / Potenza nominale",
            "c. Potenza nominale x Irraggiamento",
            "d. (Energia prodotta x costante G 0 ) / (Potenza nominale di Picco totale dei moduli x Irraggiamento)",
            "e. (Energia prodotta x costante G) / (Potenza nominale degli inverter x Irraggiamento)"
        ],
        correct: 3,
        explanation: <>
            Lo sai che, in Italia, la producibilità media di un impianto fotovoltaico fisso mono-facciale è pari a
            circa 1.300 kWh/kWp anno con picchi nel Sud Italia che possono arrivare a quasi 1.500 kWh/kWp
            anno? <br/>
            Altenia ha un dipartimento dedicato all’analisi specialistica dei dati di impianto e delle performance.
        </>,
        index: "08"
    },
    {
        question: "QUAL È IL RUOLO DELL’ARERA?",
        options: [
            "a. Erogare gli incentivi del fotovoltaico",
            "b. Eseguire il controllo fiscale sulla produzione e consumo dell’energia elettrica",
            "c. Stabilire la tassazione sugli oneri di dispacciamento",
            "d. Gestire i servizi di dispacciamento della rete",
            "e. Regolare e controllare i settori dell’energia elettrica, del gas, servizi idrici, ciclo dei rifiuti e telecalore"
        ],
        correct: 4,
        explanation: <>
            Lo sai che gli enti collegati al controllo e monitoraggio degli impianti di produzione di energia,
            gestiscono ogni anno circa 2.000.000 di impianti fotovoltaici di ogni tipologia e dimensione? <br/>
            Altenia ha un dipartimento di Asset Management dedicato alla gestione pratiche amministrative
            con i principali enti pubblici e privati, e può supportare i propri clienti su tutti gli adempimenti
            obbligatori.
        </>,
        index: "09"
    },
    {
        question: "OGNI QUANTO DEVONO ESSERE SOTTOPOSTI A ISPEZIONE PERIODICA E RIPETIZIONE DEI TEST ELETTRICI I GUANTI DIELETTRICI DI CLASSE 1-2-3-4 SECONDO LA NORMA EN 60903:2003?",
        options: [
            "a. Una volta all’anno",
            "b. Ogni sei mesi",
            "c. Si definisce la periodicità in base all’utilizzo",
            "d. Solo se usurati",
            "e. Non necessario"
        ],
        correct: 1,
        explanation: <>
            Dal 1° ottobre 2024 è entrato in vigore l’obbligo di richiesta della patente a crediti per le imprese e
            lavoratori autonomi che svolgono attività nei cantieri. <br/>
            Lo sapevi che Altenia applicava già nei suoi cantieri la patente a crediti prima dell’entrata in vigore
            della normativa?
        </>,
        index: "10"
    }
]